import gql from 'graphql-tag';
import { SURVEY_TYPE } from './SurveyType.gql';
import { ANSWER_TYPE_CONNECTION } from './AnswerTypeConnection.gql';

export const RESPONSE_TYPE = gql`
  ${SURVEY_TYPE}, ${ANSWER_TYPE_CONNECTION}
  fragment ResponseType on ResponseType {
    id
    survey {
      ...SurveyType
    }
    responseDuration
    responseDate
    norm
    answerSet {
      ...AnswerTypeConnection
    }
  }
`;
